import React from "react";
//import PragatiLogo from "./../../../../assets/pragati-tag.svg";
import PragatiPipelineLogo from "./../../../../assets/pragati pipeline without shadow.svg";

export const PragatiPipeline = ({ className, title, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={PragatiPipelineLogo} />
    </div>
  ) : null;
};
